import i18n from "@/lib/i18n";

export function fmtSubtitle(levels: { min: number; max: number }): string {
  const { min, max } = levels;
  if (min === max) {
    return i18n.t("admin.widgets.fields.model_map.map_layers.level_single", { level: min });
  }
  return i18n.t("admin.widgets.fields.model_map.map_layers.level_range", { min, max });
}
